module.exports = __webpack_public_path__ + "img/imageGalery6.0953410f.jpg";